module.exports = __webpack_public_path__ + "assets/back-btn-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/back-btn-icon.png
// module id = 708
// module chunks = 0